<template>
  <div>
    <transition
      name="component-fade"
      mode="out-in"
    >
      <div class="card m-b-md">
        <header class="card-header">
          <span class="card-header-title title is-5 has-text-weight-light">
            Ajouté le {{ order.payment_date | moment }}
          </span>
        </header>

        <div class="card-content">
          <strong>{{ order.payment_total }} {{ order.payment_currency }}</strong> par
          <span
            v-if="order.payment_mode === 'CB'"
            class="payment-mode"
          >
            {{ $t('payments.mode.CB') }}
          </span>
          <span
            v-if="order.payment_mode === 'BANK-CHECK'"
            class="payment-mode"
          >
            {{ $t('payments.mode.BANK-CHECK') }}
          </span>
          <span
            v-if="order.payment_mode === 'BANK-TRANSFER'"
            class="payment-mode"
          >
            {{ $t('payments.mode.BANK-TRANSFER') }}
          </span>
          <span
            v-if="order.payment_mode === 'BANK-DEBIT'"
            class="payment-mode"
          >
            {{ $t('payments.mode.BANK-DEBIT') }}
          </span>
          <span
            v-if="order.payment_mode === 'BANK-NOTE'"
            class="payment-mode"
          >
            {{ $t('payments.mode.BANK-NOTE') }}
          </span>
        </div>
        <footer class="card-footer">
          <span v-if="$route.matched[0].meta.schoolType === 'highschool'">
            <router-link
              class="card-footer-item"
              :to="{ name: 'highschool-order', params: {orderId: order.id}}"
            >
              {{ $t('shop.orders.order_details') }}
            </router-link>
          </span>
          <span v-if="$route.matched[0].meta.schoolType === 'eschool'">
            <router-link
              class="card-footer-item"
              :to="{ name: 'eshop-order', params: {orderId: order.id}}"
            >
              {{ $t('shop.orders.order_details') }}
            </router-link>
          </span>
        </footer>
      </div>
    </transition>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'

export default {
  props: {
    order: {type: Object}
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions(
        'orders', [
          'selectOrder',
        ]
    )
  },
  filters: {
    moment: function (date) {
      return moment(date, 'DD/MM/YYYY hh:mm').format('LL')
    }
  }
}
</script>

<style scoped>

</style>
